class ProductStickyBar extends HTMLElement {
  constructor() {
    super();

    this.handleIntersection = this.handleIntersection.bind(this);
    this.handleVariantChange = this.handleVariantChange.bind(this);
    this.getStickyBarJsonData = this.getStickyBarJsonData.bind(this);

    this.elements = {
      builder: document.querySelector('product-builder'),
      builder_sticky_bar: document.querySelector('.product-sticky-bar'),
      add_to_cart_btn: document.querySelectorAll('button[type="submit"][name="add-to-cart"]'),
      savings_amount: document.querySelectorAll('.js-builder-savings'),
      total_price: document.querySelectorAll('.js-builder-total'),
      variantSelector: document.querySelector(`variant-selects`),
    };

    this.getStickyBarJsonData();
    this.handleIntersection(this.elements.builder, this.elements.builder_sticky_bar);
    if (this.elements.variantSelector && this.stickyBarJSON.productTemplate !== "bundle") {
      this.elements.variantSelector.addEventListener('variantChanged', this.handleVariantChange);
    }
  }

  handleIntersection(builder, stickyBar) {
    let previousY = 0;
    const sectionActive = [builder];
    if (sectionActive && sectionActive[0]) {
      sectionActive.forEach((section) => {
        var observer = new IntersectionObserver(
          function (entries) {
            const { isIntersecting, target, boundingClientRect, intersectionRect, intersectionRatio } = entries[0];
            if (isIntersecting && intersectionRect.top > 0) {
              stickyBar.classList.add('bottom');
              stickyBar.classList.add('animate-bar');
            }
            if (isIntersecting && intersectionRect.top <= 0) {
              stickyBar.classList.add('bottom');
            }

            if (!isIntersecting) {
              stickyBar.classList.remove('bottom');
              stickyBar.classList.remove('animate-bar');
            }
          },
          {
            threshold: [0.15],
          }
        );

        observer.observe(section);
      });
    }
  }

  handleVariantChange(e) {
      // update in stock / out of stock
      if (e && e.detail && e.detail.selectedVariant) {
        const total_savings =
          e.detail.selectedVariant.compareAtPrice && e.detail.selectedVariant.compareAtPrice - e.detail.selectedVariant.price > 0
            ? Shopify.formatMoney(e.detail.selectedVariant.compareAtPrice - e.detail.selectedVariant.price, '${{ amount }}')
            : Shopify.formatMoney(0, '${{ amount }}');
        const total_price = Shopify.formatMoney(e.detail.selectedVariant.price, '${{ amount }}');
        Array.from(this.elements.savings_amount).forEach((savings_el) => (savings_el.textContent = total_savings));
        Array.from(this.elements.total_price).forEach((price_el) => (price_el.textContent = total_price));
      }

      if (e.detail.selectedVariant && e.detail.selectedVariant.available) {
        // update purchase action - enable atc
        Array.from(this.elements.add_to_cart_btn).forEach((atc_btn) => {
          atc_btn.setAttribute('aria-disabled', false);
          atc_btn.removeAttribute('disabled');
          atc_btn.classList.remove('builder_atc-oos', 'button--secondary-inverse');
          atc_btn.classList.add('builder_atc', 'button--primary');

          if (e.detail.selectedVariant.preorder_enabled) {
            atc_btn.children[0].textContent = window.variantStrings.preOrder;
          } else {
            atc_btn.children[0].textContent = window.variantStrings.addToCart;
          }
        });
      }
      if (e.detail.selectedVariant && !e.detail.selectedVariant.available) {
        //update purchase action - disable atc
        Array.from(this.elements.add_to_cart_btn).forEach((atc_btn) => {
          atc_btn.setAttribute('aria-disabled', true);
          atc_btn.setAttribute('disabled', 'true');
          atc_btn.classList.remove('builder_atc', 'button--primary');
          atc_btn.classList.add('builder_atc-oos', 'button--secondary-inverse');
          atc_btn.children[0].textContent = window.variantStrings.soldOut;
        });
      }

      if (!e.detail.selectedVariant) {
        //update purchase action - disable atc
        Array.from(this.elements.add_to_cart_btn).forEach((atc_btn) => {
          atc_btn.setAttribute('aria-disabled', true);
          atc_btn.setAttribute('disabled', 'true');
          atc_btn.classList.remove('builder_atc', 'button--primary');
          atc_btn.classList.add('builder_atc-oos', 'button--secondary-inverse');
          atc_btn.children[0].textContent = window.variantStrings.unavailable;
        });
      }
  }

  getStickyBarJsonData() {
    this.stickyBarJSON = this.stickyBarJSON || JSON.parse(this.querySelector('[id^=StickyBarJSON-]').textContent);
    return this.stickyBarJSON;
  }
}

customElements.define('product-sticky-bar', ProductStickyBar);
